import { styled } from "../../../../styles";

export const ImageContainer = styled("div", {
  overflowY: "overlay",
  maxHeight: "100%",

  zIndex: 1000,

  borderRadius: "8px",

  width: "100%",
  minHeight: "426px",

  border: "1px solid #ECECEC",
  backgroundColor: "$white",
  color: "$black",

  boxSizing: "border-box",

  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  rowGap: "10px",

  p: {
    width: "418px",
    marginTop: "30px",
    textAlign: "center",

    button: {
      background: "none",
      color: "#7562A8",
      border: "none",
      padding: 0,
      font: "inherit",
      cursor: "pointer",
      outline: "inherit",
      fontWeight: "600",
    },
  },
});

export const PromsTableContainer = styled("div", {
  width: "100%",
  height: "420px",
  fontSize: "14px",
  minHeight: "420px",
  overflow: "auto",
});

export const PromsTableInnerContainer = styled("div", {
  width: "100%",
  height: "420px",
  fontSize: "14px",
  minHeight: "420px",
  overflow: "auto",

  "@media screen and (max-width: 1100px)": {
    width: "1000px",
  },
});

export const NoContentMessage = styled("p", {
  marginTop: "10px !important",

  fontFamily: "$openSans",
  fontWeight: "400",
  fontSize: "16px",
  lineHeight: "21px",
});

export const AddFormTitle = styled("div", {
  color: "$charcoal",
  fontWeight: "600",
  fontSize: "12px",
  lineHeight: "17px",
  cursor: "pointer",
  position: "absolute",
  top: "8px",
  right: "10px",
  borderRadius: "6px",
  padding: "0 2px",

  "&:hover": {
    color: "var(--colors-portal-small-add-button-hover)",
  },
});

export const LoadingMoreContainer = styled("div", {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  // Minimal height for IntersectionObserver detection, expands when spinner is shown
  minHeight: "1px",
  variants: {
    isLoading: {
      true: {
        padding: "8px 0",
      },
    },
  },
});
